import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule, provideDefaultConfig } from '@spartacus/core';
import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';
import { ComponentesModule } from './components/components.module';
import { FooterComponent } from './components/footer/footer.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';

const TermsAndConditionsConfig: LayoutConfig = {
  launch: {
    TERMS_CONDITIONS: {
      inlineRoot: true,
      component: TermsConditionsComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComponentesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: FooterComponent,
        },
      },
    }),
  ],
  providers: [provideDefaultConfig(TermsAndConditionsConfig)],
})
export class CustomFooterModule {}
